import React from 'react'
import AboutMainBanner from '../templates/About/aboutMainBanner'
import AboutInfo from '../templates/About/aboutInfo'
import Board from '../templates/About/board'
import HomeMission from '../templates/About/mission'

export default function AboutUs() {
  return (
    <div>
      <AboutMainBanner />
      <AboutInfo />
      <Board />
      <HomeMission />
    </div>
  )
}
